import { SET_DUPLICATE_PARTNER } from './types';

const setDuplicatePartner = (isDuplicatePartner) => ({
  type: SET_DUPLICATE_PARTNER,
  isDuplicatePartner
});

export default setDuplicatePartner;
